import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyCheckbox", "yearlyCheckbox", "monthlySubmit", "yearlySubmit",
                     "tierRadio", "planTierField", "tierCard"]

  connect() {
    this.updateButtonStates()
  }

  selectTier(event) {
    const selectedTier = event.currentTarget.value

    // Update all plan tier hidden fields (there may be multiple in different forms)
    this.planTierFieldTargets.forEach(field => {
      field.value = selectedTier
    })

    // Update visual selection on tier cards
    this.tierCardTargets.forEach(card => {
      if (card.dataset.tier === selectedTier) {
        card.classList.add("ring-2", "ring-green-500")
        card.classList.remove("ring-1", "ring-gray-200")
      } else {
        card.classList.remove("ring-2", "ring-green-500")
        card.classList.add("ring-1", "ring-gray-200")
      }
    })

    this.updateButtonStates()
  }

  updateButtonStates() {
    if (this.hasMonthlyCheckboxTarget && this.hasMonthlySubmitTarget) {
      this.monthlySubmitTarget.disabled = !this.monthlyCheckboxTarget.checked
    }

    if (this.hasYearlyCheckboxTarget && this.hasYearlySubmitTarget) {
      const termsChecked = this.yearlyCheckboxTarget.checked
      const tierSelected = !this.hasPlanTierFieldTarget || this.planTierFieldTarget.value !== ""
      this.yearlySubmitTarget.disabled = !(termsChecked && tierSelected)
    }
  }

  submitMonthly(event) {
    if (!this.monthlyCheckboxTarget.checked) {
      event.preventDefault()
      this.showError()
    }
  }

  submitYearly(event) {
    if (!this.yearlyCheckboxTarget.checked) {
      event.preventDefault()
      this.showError()
    }
  }

  showError() {
    const errorMessage = this.data.get("errorMessage") || "You must accept the terms and conditions to proceed"
    alert(errorMessage)
  }
}
